import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { auth_actions } from "../../../../redux-store";
import { get_for_customer } from "../../../../utils";
import { removeDefaultPayment } from "../../../../redux-store/paymentMethod/action";

class TopBarDark extends Component {
  
  render() {
    const { user, logout, removeDefaultPayment } = this.props;
    let accountdropdown = null;
    if (user) {
      accountdropdown = (
        <Fragment>
          {user?.user?.role === "merchant" || user?.user?.role === "customer" ? (
            <li>
              <Link
                to={`${process.env.PUBLIC_URL}/dashboard/${user?.user?.role}`}
              >
                Dashboard
              </Link>
            </li>
          ) : (
            <li>
              <Link
                to={`${process.env.PUBLIC_URL}/dashboard/${user?.user?.role}/account`}
              >
                Dashboard
              </Link>
            </li>
          )}
          <hr />
          <li>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                logout();
                removeDefaultPayment()
                this.props.history.replace("/");
              }}
            >
              Logout
            </Link>
          </li>
        </Fragment>
      );
    } else {
      accountdropdown = (
        <Fragment>
          <li>
            <Link to="/login" data-lng="en">
              Login
            </Link>
          </li>
          <hr />
          <li>
            <Link to="/register/customer" data-lng="es">
              Customer Register
            </Link>
          </li>
          <li>
            <Link to="/register/member" data-lng="es">
              Promoter Register
            </Link>
          </li>
          <li>
            <Link to="/register/merchant" data-lng="es">
              Retailer Register
            </Link>
          </li>
          <li>
            <Link to="/signup/brand" data-lng="es">
              Brand Register
            </Link>
          </li>
        </Fragment>
      );
    }
    return (
      <div className="top-header top-header-dark3">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="header-contact">
                <ul>
                  <li>Welcome to eksplode!</li>
                  {/* <li>
                    <i className="fa fa-phone" aria-hidden="true" />
                    Call Us: 844 eksplode
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-lg-6 text-right">
              <ul className="header-dropdown">
                {/* {get_for_customer(
                  user,
                  <li className="mobile-wishlist">
                    <Link to={`${process.env.PUBLIC_URL}/wishlist`}>
                      <i className="fa fa-heart" aria-hidden="true" /> wishlist
                    </Link>
                  </li>
                )} */}

                <li
                  className="onhover-dropdown mobile-account"
                  style={{ paddingRight: "15px" }}
                >
                  My Account
                  <ul className="onhover-show-div">{accountdropdown}</ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(auth_actions.logout()),
  removeDefaultPayment: () => dispatch(removeDefaultPayment()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TopBarDark)
);
